import React from "react";
import { AddDetailDrawer } from "./AddDetailDrawer";
import { DataBox } from "./DataBox";
import { YhPageHeader } from "@/components/YhPageHeader";

export function BaseWarehouse() {
    return (
        <>
            <YhPageHeader title="仓库管理" />
            <DataBox />
            <AddDetailDrawer />
        </>
    );
}

